import React, { useEffect, useState } from 'react';

import { StateInitial } from './StateInitial';
import { StateLoading } from './StateLoading';
import { StateRequestCallback } from './StateRequestCallback';
import { EarlySettlementData } from 'cpie-common';
import { StateRequestSubmitted } from './StateRequestSubmitted';
import { StateToBeContacted } from './StateToBeContacted';
import { useDealerCallback } from './useDealerCallback';

enum State {
    LOADING = 'LOADING',
    INITIAL = 'INITIAL',
    REQUEST_CALLBACK = 'REQUEST_CALLBACK',
    CALLBACK_REQUEST_SUBMITTED = 'CALLBACK_REQUEST_SUBMITTED',
    CALLBACK_REQUEST_TO_BE_CONTACTED = 'CALLBACK_REQUEST_TO_BE_CONTACTED',
}

export const DealerCallback = ({
    contractNumber,
    encryptedContractNumber,
    earlySettlementData,
}: {
    contractNumber: string;
    encryptedContractNumber: string;
    earlySettlementData: EarlySettlementData;
}) => {
    const [state, setState] = useState<State>(State.LOADING);
    const { isLoading, data } = useDealerCallback(contractNumber);

    useEffect(() => {
        if (isLoading) {
            setState(State.LOADING);
            return;
        }

        if (data?.callbackStatus === 'TO_BE_CONTACTED') {
            setState(State.CALLBACK_REQUEST_TO_BE_CONTACTED);
            return;
        }

        setState(State.INITIAL);
    }, [isLoading]);

    switch (state) {
        case State.LOADING:
            return <StateLoading />;
        case State.INITIAL:
            return <StateInitial onRequestCallback={() => setState(State.REQUEST_CALLBACK)} />;
        case State.REQUEST_CALLBACK:
            return (
                <StateRequestCallback
                    contractNumber={contractNumber}
                    encryptedContractNumber={encryptedContractNumber}
                    earlySettlementData={earlySettlementData}
                    onStepComplete={() => setState(State.CALLBACK_REQUEST_SUBMITTED)}
                />
            );
        case State.CALLBACK_REQUEST_SUBMITTED:
            return <StateRequestSubmitted />;
        case State.CALLBACK_REQUEST_TO_BE_CONTACTED:
            return <StateToBeContacted />;
    }
};
